export default function (api) {
  const baseUrl = "/api";
  return {
    // 用户
    login (data) {
      return api.post(baseUrl + "/login", data);
    },
    logout () {
      return api.post(baseUrl + "/logout");
    },
    changePwd(data) {
      return api.post(baseUrl + "/auth/changePwd", data);
    },
    getUserInfo () {
      return api.get(baseUrl + "/userInfo");
    },

    getCompanyList (data) {
      return api.get(baseUrl + "/company", {
        params: data
      });
    },
    getCompanyDetail (id) {
      return api.get(baseUrl + "/company/" + id);
    },
    getCompanyStaffList (id, data) {
      return api.get(baseUrl + "/company/" + id + "/staff", {
        params: data
      });
    },
    getSalesStaffList (data) {
      return api.get(baseUrl + "/salesStaff", {
        params: data
      });
    },
    getStaffList () {
      return api.get(baseUrl + "/allStaff");
    },
    putCompany (id, data) {
      return api.put(baseUrl + "/company/" + id, data);
    },
    postCompany (data) {
      return api.post(baseUrl + "/company", data);
    },
    deleteCompany (id) {
      return api.delete(baseUrl + "/company/" + id);
    },
    getPrefCodeList () {
      return api.get(baseUrl + "/prefCode");
    },
    getPropretyCodeList () {
      return api.get(baseUrl + "/propertyCode");
    },
    getCompanyOpportunityList (id, data) {
      return api.get(baseUrl + "/company/" + id + "/opportunity", {
        params: data
      });
    },
    getCompanyActionHistoryList (id, data) {
      return api.get(baseUrl + "/company/" + id + "/actionHistory", {
        params: data
      });
    },
    getCompanyActionHistoryDetail (id, actionHistoryId) {
      return api.get(baseUrl + "/company/" + id + "/actionHistory/" + actionHistoryId);
    },
    postCompanyActionHistory (id, data) {
      return api.post(baseUrl + "/company/" + id + "/actionHistory", data);
    },
    putCompanyActionHistory (id, actionHistoryId, data) {
      return api.put(baseUrl + "/company/" + id + "/actionHistory/" + actionHistoryId, data);
    },
    deleteCompanyActionHistory (id, actionHistoryId) {
      return api.delete(baseUrl + "/company/" + id + "/actionHistory/" + actionHistoryId);
    },
    getCompanyOwnerParkingLotList (id, data) {
      return api.get(baseUrl + "/company/" + id + "/ownerParkingLot", {
        params: data
      });
    },
    getCompanyLenderParkingLotList (id, data) {
      return api.get(baseUrl + "/company/" + id + "/lenderParkingLot", {
        params: data
      });
    },
    getCompanyAmParkingLotList (id, data) {
      return api.get(baseUrl + "/company/" + id + "/amParkingLot", {
        params: data
      });
    },
    getCompanyPmParkingLotList (id, data) {
      return api.get(baseUrl + "/company/" + id + "/pmParkingLot", {
        params: data
      });
    },
    getCompanyBmParkingLotList (id, data) {
      return api.get(baseUrl + "/company/" + id + "/bmParkingLot", {
        params: data
      });
    },
    getCompanyOperationHistory (id, data) {
      return api.get(baseUrl + "/company/" + id + "/operationHistory", {
        params: data
      });
    },
    companyGetViewSetting () {
      return api.get(baseUrl + "/company/view");
    },
    companyPostViewSetting (data) {
      return api.post(baseUrl + "/company/view", data);
    },
    companyGetViewDetail (id) {
      return api.get(baseUrl + "/company/view/" + id);
    },
    companyPutViewSetting (id, data) {
      return api.put(baseUrl + "/company/view/" + id, data);
    },
    companyDeleteViewSetting (id) {
      return api.delete(baseUrl + "/company/view/" + id);
    },
    companyViewDefault (id) {
      return api.put(baseUrl + "/company/view/default/" + id);
    },
    getCompanySmmaryList (data) {
      return api.get(baseUrl + "/company/summaryList", {
        params: data
      });
    },
    getCompanyAccount (id) {
      return api.get(baseUrl + "/company/" + id + "/account");
    },
    putCompanyAccount (id, data) {
      return api.put(baseUrl + "/company/" + id + "/account", data);
    },
    getCompanyAttachment (id, data) {
      return api.get(baseUrl + `/company/${id}/attachment`, {
        params: data
      });
    },
    getCompanyAttachmentDetail (id, attachmentId) {
      return api.get(baseUrl + `/company/${id}/attachment/${attachmentId}`);
    },
    postCompanyAttachment (id, data) {
      return api.post(baseUrl + `/company/${id}/attachment
      `, data);
    },
    putCompanyAttachment (id, attachmentId, data) {
      return api.put(baseUrl + `/company/${id}/attachment/${attachmentId}`, data);
    },
    deleteCompanyAttachment (id, attachmentId) {
      return api.delete(baseUrl + `/company/${id}/attachment/${attachmentId}`);
    },
    // 管理会社担当者
    getStaffDetail (id) {
      return api.get(baseUrl + "/staff/" + id);
    },
    putStaff (id, data) {
      return api.put(baseUrl + "/staff/" + id, data);
    },
    postStaff (data) {
      return api.post(baseUrl + "/staff", data);
    },
    deleteStaff (id) {
      return api.delete(baseUrl + "/staff/" + id);
    },
    getStaffOpportunityList (id, data) {
      return api.get(baseUrl + "/staff/" + id + "/opportunity", {
        params: data
      });
    },
    getStaffOwnerParkingLotList (id, data) {
      return api.get(baseUrl + "/staff/" + id + "/ownerParkingLot", {
        params: data
      });
    },
    getStaffLenderParkingLotList (id, data) {
      return api.get(baseUrl + "/staff/" + id + "/lenderParkingLot", {
        params: data
      });
    },
    getStaffAmParkingLotList (id, data) {
      return api.get(baseUrl + "/staff/" + id + "/amParkingLot", {
        params: data
      });
    },
    getStaffPmParkingLotList (id, data) {
      return api.get(baseUrl + "/staff/" + id + "/pmParkingLot", {
        params: data
      });
    },
    getStaffBmParkingLotList (id, data) {
      return api.get(baseUrl + "/staff/" + id + "/bmParkingLot", {
        params: data
      });
    },
    getStaffActionHistoryList (id, data) {
      return api.get(baseUrl + "/staff/" + id + "/actionHistory", {
        params: data
      });
    },
    postStaffActionHistory (id, data) {
      return api.post(baseUrl + "/staff/" + id + "/actionHistory", data);
    },
    getStaffActionHistoryDetail (id, actionHistoryId) {
      return api.get(baseUrl + "/staff/" + id + "/actionHistory/" + actionHistoryId);
    },
    putStaffActionHistory (id, actionHistoryId, data) {
      return api.put(baseUrl + "/staff/" + id + "/actionHistory/" + actionHistoryId, data);
    },
    deleteStaffActionHistory (id, actionHistoryId) {
      return api.delete(baseUrl + "/staff/" + id + "/actionHistory/" + actionHistoryId);
    },
    getStaffOperationHistory (id, data) {
      return api.get(baseUrl + "/staff/" + id + "/operationHistory", {
        params: data
      });
    },
    putStaffMailCheck (data) {
      return api.put(baseUrl + "/staff/mailCheck", data);
    },
    // 物件
    getParkingLotList (data) {
      return api.get(baseUrl + "/parkingLot", {
        params: data
      });
    },
    getParkingLotDetail (id) {
      return api.get(baseUrl + "/parkingLot/" + id);
    },
    putParkingLotBasicInfo (id, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/basicInfo", data);
    },
    putParkingLotCompany (id, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/company", data);
    },
    putParkingLotCompanyAm (id, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/companyAm", data);
    },
    putParkingLotCompanyBm (id, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/companyBm", data);
    },
    putParkingLotCompanyPm (id, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/companyPm", data);
    },
    putParkingLotSendList (id, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/sendList", data);
    },
    putParkingLotFaultContact (id, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/faultContact", data);
    },
    putParkingLotSummary (id, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/summary", data);
    },
    putParkingLotContractSummary (id, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/contractSummary", data);
    },
    putParkingLotNavi (id, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/navi", data);
    },
    putParkingLotOther (id, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/other", data);
    },
    putParkingLotContractHistory (id, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/contractHistory", data);
    },
    parkingLotGetViewSetting () {
      return api.get(baseUrl + "/parkingLot/view");
    },
    parkingLotPostViewSetting (data) {
      return api.post(baseUrl + "/parkingLot/view", data);
    },
    parkingLotGetViewDetail (id) {
      return api.get(baseUrl + "/parkingLot/view/" + id);
    },
    parkingLotPutViewSetting (id, data) {
      return api.put(baseUrl + "/parkingLot/view/" + id, data);
    },
    parkingLotDeleteViewSetting (id) {
      return api.delete(baseUrl + "/parkingLot/view/" + id);
    },
    parkingLotViewDefault (id) {
      return api.put(baseUrl + "/parkingLot/view/default/" + id);
    },
    getParkingLotOpportunityList (id, data) {
      return api.get(baseUrl + "/parkingLot/" + id + "/opportunity", {
        params: data
      });
    },
    getParkingLotActionHistoryList (id, data) {
      return api.get(baseUrl + "/parkingLot/" + id + "/actionHistory", {
        params: data
      });
    },
    getParkingLotActionHistoryDetail (id, actionHistoryId) {
      return api.get(baseUrl + "/parkingLot/" + id + "/actionHistory/" + actionHistoryId);
    },
    postParkingLotActionHistory (id, data) {
      return api.post(baseUrl + "/parkingLot/" + id + "/actionHistory", data);
    },
    putParkingLotActionHistory (id, actionHistoryId, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/actionHistory/" + actionHistoryId, data);
    },
    deleteParkingLotActionHistory (id, actionHistoryId) {
      return api.delete(baseUrl + "/parkingLot/" + id + "/actionHistory/" + actionHistoryId);
    },
    getParkingLotOperationHistory (id, data) {
      return api.get(baseUrl + "/parkingLot/" + id + "/operationHistory", {
        params: data
      });
    },
    getParkingLotOpportunityHistory (id) {
      return api.get(baseUrl + "/parkingLot/" + id + "/opportunityHistory");
    },
    getParkingLotNearestStationList (id) {
      return api.get(baseUrl + "/parkingLot/" + id + "/nearestStation");
    },
    getParkingLotNearestStationDetail (id, nearestStationId) {
      return api.get(baseUrl + "/parkingLot/" + id + "/nearestStation/" + nearestStationId);
    },
    postParkingLotNearestStation (id, data) {
      return api.post(baseUrl + "/parkingLot/" + id + "/nearestStation", data);
    },
    putParkingLotNearestStation (id, nearestStationId, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/nearestStation/" + nearestStationId, data);
    },
    deleteParkingLotNearestStation (id, nearestStationId) {
      return api.delete(baseUrl + "/parkingLot/" + id + "/nearestStation/" + nearestStationId);
    },
    getParkingLotKeyOrderList (id) {
      return api.get(baseUrl + "/parkingLot/" + id + "/keyOrder");
    },
    getParkingLotKeyOrderDetail (id, nearestStationId) {
      return api.get(baseUrl + "/parkingLot/" + id + "/keyOrder/" + nearestStationId);
    },
    postParkingLotKeyOrder (id, data) {
      return api.post(baseUrl + "/parkingLot/" + id + "/keyOrder", data);
    },
    putParkingLotKeyOrder (id, nearestStationId, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/keyOrder/" + nearestStationId, data);
    },
    deleteParkingLotKeyOrder (id, nearestStationId) {
      return api.delete(baseUrl + "/parkingLot/" + id + "/keyOrder/" + nearestStationId);
    },
    getParkingLotForbidPostingList (id) {
      return api.get(baseUrl + "/parkingLot/" + id + "/forbidPosting");
    },
    getParkingLotForbidPostingDetail (id, nearestStationId) {
      return api.get(baseUrl + "/parkingLot/" + id + "/forbidPosting/" + nearestStationId);
    },
    postParkingLotForbidPosting (id, data) {
      return api.post(baseUrl + "/parkingLot/" + id + "/forbidPosting", data);
    },
    putParkingLotForbidPosting (id, nearestStationId, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/forbidPosting/" + nearestStationId, data);
    },
    deleteParkingLotForbidPosting (id, nearestStationId) {
      return api.delete(baseUrl + "/parkingLot/" + id + "/forbidPosting/" + nearestStationId);
    },
    getParkingLotAppendixList (id) {
      return api.get(baseUrl + "/parkingLot/" + id + "/appendix");
    },
    getParkingLotAppendixDetail (id, appendixType) {
      return api.get(baseUrl + "/parkingLot/" + id + "/appendix/" + appendixType);
    },
    putParkingLotAppendix (id, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/appendix/", data);
    },
    getParkingLotStaffList (id, data) {
      return api.get(baseUrl + "/parkingLot/" + id + "/staff", {
        params: data
      });
    },
    getParkingAttachmentPublicDocList (id, data) {
      return api.get(baseUrl + "/parkingLot/" + id + "/attachment/publicDoc", {
        params: data
      });
    },
    getParkingAttachmentPrivateDocList (id, data) {
      return api.get(baseUrl + "/parkingLot/" + id + "/attachment/privateDoc", {
        params: data
      });
    },
    getParkingAttachmentImageList (id, data) {
      return api.get(baseUrl + "/parkingLot/" + id + "/attachment/image", {
        params: data
      });
    },
    postParkingLotAttachmentPublicDoc (id, data) {
      return api.post(baseUrl + "/parkingLot/" + id + "/attachment/publicDoc", data);
    },
    postParkingLotAttachmentPrivateDoc (id, data) {
      return api.post(baseUrl + "/parkingLot/" + id + "/attachment/privateDoc", data);
    },
    postParkingLotAttachmentImage (id, data) {
      return api.post(baseUrl + "/parkingLot/" + id + "/attachment/image", data);
    },
    putParkingLotAttachment (id, publicDocId, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/attachment/" + publicDocId, data);
    },
    getParkingLotAttachment (id, publicDocId) {
      return api.get(baseUrl + "/parkingLot/" + id + "/attachment/" + publicDocId);
    },
    deleteParkingLotAttachment (id, publicDocId) {
      return api.delete(baseUrl + "/parkingLot/" + id + "/attachment/" + publicDocId);
    },
    getParkingLotAccount (id) {
      return api.get(baseUrl + "/parkingLot/" + id + "/account");
    },
    putParkingLotAccount (id, data) {
      return api.put(baseUrl + "/parkingLot/" + id + "/account", data);
    },
    postParkingLotAgreementDocExport (id, data) {
      return api.post(baseUrl + "/parkingLot/" + id + "/agreementDocExport", data, {
        responseType: 'blob'
      });
    },
    // 车室
    getParkingLotPositionList (parkinglotId, data) {
      return api.get(baseUrl + "/parkingLot/" + parkinglotId + "/position", {
        params: data
      });
    },
    getParkingLotPositionDetail (parkinglotId, positionId) {
      return api.get(baseUrl + "/parkingLot/" + parkinglotId + "/position/" + positionId);
    },
    putParkingLotPosition (parkinglotId, positionId, data) {
      return api.put(baseUrl + "/parkingLot/" + parkinglotId + "/position/" + positionId, data);
    },
    postParkingPositionChangeManagementFee (id, positionId, data) {
      return api.post(baseUrl + "/parkingLot/" + id + "/position/" + positionId + "/updateManagementFee", data);
    },
    getParkingLotPositionOperationHistoryList (parkinglotId, positionId, data) {
      return api.get(baseUrl + "/parkingLot/" + parkinglotId + "/position/" + positionId + "/operationHistory", {
        params: data
      });
    },
    getParkingLotGroupedPosition (parkinglotId) {
      return api.get(baseUrl + "/parkingLot/" + parkinglotId + "/groupedPosition");
    },
    getParkingLotCombinePositions (parkinglotId) {
      return api.get(baseUrl + "/parkingLot/" + parkinglotId + "/combinePositions");
    },
    getParkingLotCompanyStaffHistory (id, data) {
      return api.get(baseUrl + `/parkingLot/${id}/companyStaffHistory`, {
        params: data
      });
    },
    getParkingLotBalanceDateOption () {
      return api.get(baseUrl + `/parkingLot/balanceDateOption`);
    },
    postParkingLotBalance (data) {
      return api.post(baseUrl + `/parkingLot/balance`, data, {
        responseType: 'blob',
      });
    },
    postParkingLotPositionBulkUpdate (parkinglotId, data) {
      return api.post(baseUrl + "/parkingLot/" + parkinglotId + "/position/bulkUpdate", data);
    },

    // 商谈
    getOpportunityList (data) {
      return api.get(baseUrl + "/opportunity", {
        params: data
      });
    },
    getOpportunityDetail (id) {
      return api.get(baseUrl + "/opportunity/" + id);
    },
    deleteOpportunity (id) {
      return api.delete(baseUrl + "/opportunity/" + id);
    },
    deleteOpportunityActionHistory (id, actionHistoryId) {
      return api.delete(baseUrl + "/opportunity/" + id + "/actionHistory/" + actionHistoryId);
    },
    getOpportunityActionHistoryList (id, data) {
      return api.get(baseUrl + "/opportunity/" + id + "/actionHistory", {
        params: data
      });
    },
    getOpportunityActionHistoryDetail (id, actionHistoryId) {
      return api.get(baseUrl + "/opportunity/" + id + "/actionHistory/" + actionHistoryId);
    },
    postOpportunityActionHistory (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/actionHistory", data);
    },
    putOpportunityActionHistory (id, actionHistoryId, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/actionHistory/" + actionHistoryId, data);
    },
    patchOpportunityActionHistory (id, actionHistoryId) {
      return api.patch(baseUrl + "/opportunity/" + id + "/actionHistory/" + actionHistoryId);
    },
    getOpportunityHistoryList (id, data) {
      return api.get(baseUrl + "/opportunity/" + id + "/operationHistory", {
        params: data
      });
    },
    opportunityGetViewSetting () {
      return api.get(baseUrl + "/opportunity/view");
    },
    opportunityPostViewSetting (data) {
      return api.post(baseUrl + "/opportunity/view", data);
    },
    opportunityGetViewDetail (id) {
      return api.get(baseUrl + "/opportunity/view/" + id);
    },
    opportunityPutViewSetting (id, data) {
      return api.put(baseUrl + "/opportunity/view/" + id, data);
    },
    opportunityDeleteViewSetting (id) {
      return api.delete(baseUrl + "/opportunity/view/" + id);
    },
    opportunityViewDefault (id) {
      return api.put(baseUrl + "/opportunity/view/default/" + id);
    },
    getOpportunityNearbyOpportunity (id, data) {
      return api.get(baseUrl + "/opportunity/" + id + "/nearbyOpportunity",
        {
          params: data
        }
      );
    },
    postOpportunityNearbyOpportunitySearch (data) {
      return api.post(baseUrl + "/opportunity/nearbyOpportunity",
        data,
        {
          params: {
            page: data.page,
            size: data.size
          }
        }
      );
    },
    getOpportunityAccount (id) {
      return api.get(baseUrl + "/opportunity/" + id + "/account");
    },
    putOpportunityAccount (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/account", data);
    },
    getOpportunityTmpParkingLotOptionListMap () {
      return api.get(baseUrl + "/opportunity/tmpParkingLotOptionListMap");
    },
    postOpportunityTmpParkingLot (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/tmpParkingLot", data);
    },
    getOpportunityNearbyApParkingLot (id, data) {
      return api.get(baseUrl + "/opportunity/" + id + "/nearbyApParkingLot",
        { params: data });
    },
    postOpportunityNearbyApParkingLotSearch (data) {
      return api.post(baseUrl + "/opportunity/nearbyApParkingLot",
        data,
        {
          params: {
            page: data.page,
            size: data.size
          }
        });
    },
    getOpportunityNearbyApParkingLotCsv (id, data) {
      return api.get(baseUrl + "/opportunity/" + id + "/nearbyApParkingLotCsv", {
        params: data,
        responseType: 'blob'
      });
    },
    postOpportunityNearbyApParkingLotSearchCsv (data) {
      return api.post(baseUrl + "/opportunity/nearbyApParkingLotCsv", data, {
        params: {
          page: data.page,
          size: data.size
        },
        responseType: 'blob'
      });
    },
    getOpportunitySelfParkingPositionCsv (id, data) {
      return api.get(baseUrl + "/opportunity/" + id + "/selfApParkingPositionCsv", {
        params: data,
        responseType: 'blob'
      });
    },
    getOpportunitySalesParkingPositionList (id) {
      return api.get(baseUrl + "/opportunity/" + id + "/salesParkingPosition");
    },
    saveOpportunitySimulation (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/saveSimulation", data);
    },
    postOpportunityProcessSimulation (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/processSimulation", data);
    },
    getOpportunitytmpParkingPositionOptionListMap () {
      return api.get(baseUrl + "/opportunity/tmpParkingPositionOptionListMap");
    },
    getOpportunityParkingLotManagementFee (id) {
      return api.get(baseUrl + "/opportunity/" + id + "/managementFee");
    },
    postOpportunityTmpParkingPosition (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/tmpParkingPosition", data);
    },
    putOpportunityTmpParkingPosition (id, tmpParkingPositionId, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/tmpParkingPosition/" + tmpParkingPositionId, data);
    },
    deleteOpportunityTmpParkingPosition (id, tmpParkingPositionId) {
      return api.delete(baseUrl + "/opportunity/" + id + "/tmpParkingPosition/" + tmpParkingPositionId);
    },
    getOpportunitySelectableParkingPositionList (id, data) {
      return api.get(baseUrl + "/opportunity/" + id + "/selectableParkingPosition", {
        params: data
      });
    },
    getOpportunitySelectedParkingPositionIdList (id) {
      return api.get(baseUrl + "/opportunity/" + id + "/selectedParkingPositionId");
    },
    getOpportunityAttachmentList (id, data) {
      return api.get(baseUrl + "/opportunity/" + id + "/attachment",
        { params: data });
    },
    postOpportunityAttachment (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/attachment", data);
    },
    getOpportunityAttachmentDetail (id, attachmentId) {
      return api.get(baseUrl + "/opportunity/" + id + "/attachment/" + attachmentId);
    },
    putOpportunityAttachment (id, attachmentId, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/attachment/" + attachmentId, data);
    },
    putOpportunityAttachmentSetCopy (id, attachmentId) {
      return api.put(baseUrl + "/opportunity/" + id + "/attachment/" + attachmentId + "/setCopy");
    },
    putOpportunityAttachmentCancelCopy (id, attachmentId) {
      return api.put(baseUrl + "/opportunity/" + id + "/attachment/" + attachmentId + "/cancelCopy");
    },
    deleteOpportunityAttachment (id, attachmentId) {
      return api.delete(baseUrl + "/opportunity/" + id + "/attachment/" + attachmentId);
    },
    postOpportunitySelectParkingPosition (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/selectParkingPosition", data);
    },
    postOpportunity (data) {
      return api.post(baseUrl + "/opportunity/new", data);
    },
    getOpportunityNamePrefix (type) {
      return api.get(baseUrl + "/opportunity/namePrefix/" + type);
    },
    postOpportunityProcess (data) {
      return api.post(baseUrl + "/opportunity/process", data);
    },
    putOpportunityCenterValue (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/centerValue", data);
    },
    getOpportunityAppraisalTable (id) {
      return api.get(baseUrl + "/opportunity/" + id + "/appraisalTable");
    },
    putOpportunityProposal (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/proposal", data);
    },
    putOpportunityCompeting (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/competing", data);
    },
    putOpportunityComment (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/comment", data);
    },
    putOpportunityLenderComment (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/lenderComment", data);
    },
    putOpportunityKey (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/key", data);
    },
    putOpportunitySummary (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/summary", data);
    },
    getOpportunityConditionHistoryList (id, data) {
      return api.get(baseUrl + "/opportunity/" + id + "/conditionHistory", {
        params: data
      });
    },
    getOpportunityConditionHistoryDetail (id, conditionHistoryId) {
      return api.get(baseUrl + "/opportunity/" + id + "/conditionHistory/" + conditionHistoryId);
    },
    getOpportunityConditionHistoryNew (id) {
      return api.get(baseUrl + "/opportunity/" + id + "/conditionHistory/new");
    },
    postOpportunityConditionHistory (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/conditionHistory", data);
    },
    putOpportunityConditionHistory (id, conditionHistoryId, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/conditionHistory/" + conditionHistoryId, data);
    },
    postOpportunityConditionHistoryPermit (id, conditionHistoryId, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/conditionHistory/" + conditionHistoryId + "/permit", data);
    },
    deleteOpportunityConditionHistory (id, conditionHistoryId) {
      return api.delete(baseUrl + "/opportunity/" + id + "/conditionHistory/" + conditionHistoryId);
    },
    getOpportunityNearestStationList (id) {
      return api.get(baseUrl + "/opportunity/" + id + "/nearestStation");
    },
    getOpportunityNearestStationDetail (id, nearestStationId) {
      return api.get(baseUrl + "/opportunity/" + id + "/nearestStation/" + nearestStationId);
    },
    postOpportunityNearestStation (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/nearestStation", data);
    },
    putOpportunityNearestStation (id, nearestStationId, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/nearestStation/" + nearestStationId, data);
    },
    deleteOpportunityNearestStation (id, nearestStationId) {
      return api.delete(baseUrl + "/opportunity/" + id + "/nearestStation/" + nearestStationId);
    },
    getOpportunityForbidPostingList (id) {
      return api.get(baseUrl + "/opportunity/" + id + "/forbidPosting");
    },
    getOpportunityForbidPostingDetail (id, nearestStationId) {
      return api.get(baseUrl + "/opportunity/" + id + "/forbidPosting/" + nearestStationId);
    },
    postOpportunityForbidPosting (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/forbidPosting", data);
    },
    putOpportunityForbidPosting (id, nearestStationId, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/forbidPosting/" + nearestStationId, data);
    },
    deleteOpportunityForbidPosting (id, nearestStationId) {
      return api.delete(baseUrl + "/opportunity/" + id + "/forbidPosting/" + nearestStationId);
    },
    getOpportunityKeyOrderList (id) {
      return api.get(baseUrl + "/opportunity/" + id + "/keyOrder");
    },
    getOpportunityKeyOrderDetail (id, nearestStationId) {
      return api.get(baseUrl + "/opportunity/" + id + "/keyOrder/" + nearestStationId);
    },
    postOpportunityKeyOrder (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/keyOrder", data);
    },
    putOpportunityKeyOrder (id, nearestStationId, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/keyOrder/" + nearestStationId, data);
    },
    deleteOpportunityKeyOrder (id, nearestStationId) {
      return api.delete(baseUrl + "/opportunity/" + id + "/keyOrder/" + nearestStationId);
    },
    getOpportunityAppendix (id) {
      return api.get(baseUrl + "/opportunity/" + id + "/appendix");
    },
    getOpportunityAppendixDetail (id, type) {
      return api.get(baseUrl + "/opportunity/" + id + "/appendix/" + type);
    },
    putOpportunityAppendix (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/appendix", data);
    },
    getOpportunityStaffList (id, data) {
      return api.get(baseUrl + "/opportunity/" + id + "/staff", {
        params: data
      });
    },
    postOpportunityProposalDocExport (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/proposalDocExport", data, {
        responseType: 'blob'
      });
    },
    postOpportunityContractDocExport (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/contractDocExport", data, {
        responseType: 'blob'
      });
    },
    postOpportunityAgreementDocExport (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/agreementDocExport", data, {
        responseType: 'blob'
      });
    },
    postOpportunityKeyTakenDocExport (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/keyTakenDocExport", data, {
        responseType: 'blob'
      });
    },
    postOpportunityKeyReturnDocExport (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/keyReturnDocExport", data, {
        responseType: 'blob'
      });
    },
    postOpportunityAgreementDocExportList (data) {
      return api.post(baseUrl + "/opportunity/agreementDocExport", data, {
        responseType: 'blob'
      });
    },
    getOpportunityOpportunityList (id, data) {
      return api.get(baseUrl + "/opportunity/" + id + "/opportunity", {
        params: data
      });
    },
    getOpportunityPhaseHistory (id, data) {
      return api.get(baseUrl + "/opportunity/" + id + "/phaseHistory", {
        params: data
      });
    },
    postOpportunitySync (id) {
      return api.post(baseUrl + "/opportunity/" + id + "/sync");
    },
    postOpportunityReturnComment (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/returnComment", data);
    },
    putOpportunityAppraisalComment (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/appraisalComment", data);
    },
    getOpportunityMobileList (data) {
      return api.get(baseUrl + "/opportunity/mobile", {
        params: data
      });
    },
    putOpportunityTmpParkingLotBasicInfo (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/tmpParkingLot/basicInfo", data);
    },
    putOpportunityTmpParkingLotCompany (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/tmpParkingLot/company", data);
    },
    putOpportunityTmpParkingLotCompanyAm (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/tmpParkingLot/companyAm", data);
    },
    putOpportunityTmpParkingLotCompanyBm (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/tmpParkingLot/companyBm", data);
    },
    putOpportunityTmpParkingLotCompanyPm (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/tmpParkingLot/companyPm", data);
    },
    putOpportunityTmpParkingLotSendList (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/tmpParkingLot/sendList", data);
    },
    putOpportunityTmpParkingLotFaultContact (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/tmpParkingLot/faultContact", data);
    },
    putOpportunityTmpParkingLotSummary (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/tmpParkingLot/summary", data);
    },
    putOpportunityTmpParkingLotContractSummary (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/tmpParkingLot/contractSummary", data);
    },
    putOpportunityTmpParkingLotNavi (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/tmpParkingLot/navi", data);
    },
    putOpportunityTmpParkingLotOther (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/tmpParkingLot/other", data);
    },
    putOpportunityCompany (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/company", data);
    },
    putOpportunityAssume (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/assume", data);
    },
    putOpportunityBuildingInfo (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/buildingInfo", data);
    },
    putOpportunityParkingLotInfo (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/parkingLotInfo", data);
    },
    getOpportunityConfirmFormUrl (id) {
      return api.get(baseUrl + "/opportunity/" + id + "/confirmForm/url");
    },
    getOpportunityConfirmForm (id) {
      return api.get(baseUrl + "/opportunity/" + id + "/confirmForm");
    },
    postAdminUpdateOpportunityConfirmForm (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/confirmForm", data);
    },
    postReopenOpportunityConfirmForm (id) {
      return api.post(baseUrl + "/opportunity/" + id + "/confirmForm/reopen");
    },
    postOpportunityCopy (id, data) {
      return api.post(baseUrl + "/opportunity/" + id + "/copy", data);
    },
    getOpportunitySelfApParkingPositionList (id, data) {
      return api.get(baseUrl + "/opportunity/" + id + "/selfApParkingPosition", {
        params: data
      });
    },
    getOpportunityDocExportInfo (id) {
      return api.get(baseUrl + "/opportunity/" + id + "/docExportInfo");
    },
    postOpportunityDocExportInfo (data) {
      return api.post(baseUrl + "/opportunity/docExportInfo", data);
    },
    putOpportunityAppraisalTable (id, data) {
      return api.put(baseUrl + "/opportunity/" + id + "/appraisalTable", data);
    },
    // confirmForm
    getConfirmForm (uuid) {
      return api.get(baseUrl + "/confirmForm/" + uuid);
    },
    postConfirmForm (uuid, data) {
      return api.post(baseUrl + "/confirmForm/" + uuid, data);
    },
    postConfirmFormTempSave (uuid, data) {
      return api.post(baseUrl + "/confirmForm/" + uuid + "/tempSave", data);
    },
    postConfirmFormAttachment (uuid, data) {
      return api.post(baseUrl + "/confirmForm/" + uuid + "/attachment", data);
    },
    deleteConfirmFormAttachment (uuid, attachmentId) {
      return api.delete(baseUrl + "/confirmForm/" + uuid + "/attachment/" + attachmentId);
    },
    // chatter
    getChatterList (data) {
      return api.get(baseUrl + "/chatter", {
        params: data
      });
    },
    postChatter (data) {
      return api.post(baseUrl + "/chatter", data);
    },
    putChatter (data) {
      return api.put(baseUrl + "/chatter", data);
    },
    deleteChatter (id) {
      return api.delete(baseUrl + "/chatter/" + id);
    },
    getChatterMentionList (data) {
      return api.get(baseUrl + "/chatter/mention", {
        params: data
      });
    },
    postChatterLike (data) {
      return api.post(baseUrl + "/chatter/like", data);
    },
    deleteChatterLike (id) {
      return api.delete(baseUrl + "/chatter/like/" + id);
    },
    getChatterUser (id, data) {
      return api.get(baseUrl + `/chatter/user/${id}`, {
        params: data
      });
    },
    // mailtemplate
    getMailTemplateList (data) {
      return api.get(baseUrl + "/mailtemplate", {
        params: data
      });
    },
    getMailTemplateDetail (id) {
      return api.get(baseUrl + "/mailtemplate/" + id);
    },
    putMailTemplate (data) {
      return api.put(baseUrl + "/mailtemplate/", data);
    },
    postMailTemplate (data) {
      return api.post(baseUrl + "/mailtemplate/", data);
    },
    deleteMailTemplate (id) {
      return api.delete(baseUrl + "/mailtemplate/" + id);
    },
    // レポート
    getReportList (data) {
      return api.get(baseUrl + "/report", {
        params: data
      });
    },
    getReportDefinitionHeader () {
      return api.get(baseUrl + "/report/definition/header");
    },
    getReportDefinitionDetail (reportType) {
      return api.get(baseUrl + "/report/definition/detail/" + reportType);
    },
    postReport (data) {
      return api.post(baseUrl + "/report", data);
    },
    putReport (id, data) {
      return api.put(baseUrl + "/report/" + id, data);
    },
    getReportDetail (id) {
      return api.get(baseUrl + "/report/" + id);
    },
    deleteReport (id) {
      return api.delete(baseUrl + "/report/" + id);
    },
    getReportresultDashboard (data) {
      return api.get(baseUrl + "/reportresult/dashboard", {
        params: data
      });
    },
    getReportresultView () {
      return api.get(baseUrl + "/reportresult/view");
    },
    getReportresultViewDetail (id) {
      return api.get(baseUrl + "/reportresult/view/" + id);
    },
    postReportresultView (data) {
      return api.post(baseUrl + "/reportresult/view", data);
    },
    putReportresultView (id, data) {
      return api.put(baseUrl + "/reportresult/view/" + id, data);
    },
    deleteReportresultView (id) {
      return api.delete(baseUrl + "/reportresult/view/" + id);
    },
    getReportresultViewReportList (data) {
      return api.get(baseUrl + "/reportresult/view/report", {
        params: data
      });
    },
    getReportresultTable (data) {
      return api.get(baseUrl + "/reportresult/table", {
        params: data
      });
    },
    getReportresultTableCsv (data) {
      return api.get(baseUrl + "/reportresult/table/csv", {
        params: data,
        responseType: 'blob'
      });
    },
    getReportresultTableExcel (data) {
      return api.get(baseUrl + "/reportresult/table/excel", {
        params: data,
        responseType: 'blob'
      });
    },
    getReportresultAggregate (data) {
      return api.get(baseUrl + "/reportresult/aggregate", {
        params: data
      });
    },
    getReportresultChart (data) {
      return api.get(baseUrl + "/reportresult/chart", {
        params: data
      });
    },
    postReportTablePreview (data) {
      return api.post(baseUrl + "/reportresult/table/preview?page=0&size=999999999", data);
    },
    postReportAggregatePreview (data) {
      return api.post(baseUrl + "/reportresult/aggregate/preview", data);
    },
    postReportChartPreview (data) {
      return api.post(baseUrl + "/reportresult/chart/preview", data);
    },
    reportresultViewDefault (id) {
      return api.put(baseUrl + "/reportresult/view/default/" + id);
    },
    // view
    putViewConfig (id, data) {
      return api.put(baseUrl + "/view/" + id + "/config", data, {
        noLoading: true
      });
    },
    getViewPage (view_type) {
      return api.get(baseUrl + `/view/page/${view_type}`);
    },
    putViewPage (view_type, data) {
      return api.put(baseUrl + `/view/page/${view_type}`, data);
    },

    // common
    getActionHistoryContactTypeList () {
      return api.get(baseUrl + "/commonList/actionHistoryContactType");
    },
    getPostCode (code) {
      return api.get(baseUrl + "/postCode/" + code);
    },
    getPropertyCodeList() {
      return api.get(baseUrl + "/commonList/propertyCode");
    },
    getCommonParkingLotList (data) {
      return api.get(baseUrl + "/parkingLot/parkingLot", {
        params: data
      });
    },
    getCommonOpportunityTmpParkingLotList (data) {
      return api.get(baseUrl + "/opportunity/tmpParkingLot", {
        params: data
      });
    },
    getCommonStaffList (data) {
      return api.get(baseUrl + "/staff", {
        params: data
      });
    },
    putSearchList (data) {
      return api.put(baseUrl + "/search", data);
    },
    putSearchChangePage (data) {
      return api.put(baseUrl + "/search/changePage", data);
    },
    getCommonListActionHistoryTitle () {
      return api.get(baseUrl + "/commonList/actionHistoryTitle");
    },
    getCommonListActionHistoryStatus () {
      return api.get(baseUrl + "/commonList/actionHistoryStatus");
    },
    getAccessHistory (data) {
      return api.get(baseUrl + "/accesshistory", {
        params: data,
        noLoading: true
      });
    },
    searchStation (data) {
      return api.get(baseUrl + "/station/search", {
        params: data
      });
    },
    // home
    getHomeTodoList (data) {
      return api.get(baseUrl + "/home/todo", {
        params: data
      });
    },
    getHomeChatterList (data) {
      return api.get(baseUrl + "/home/chatter", {
        params: data
      });
    },
    getHomeAccesshistoryList (data) {
      return api.get(baseUrl + "/home/accesshistory", {
        params: data
      });
    },
    // 地域管理
    getAreaList (data) {
      return api.get(baseUrl + "/area", {
        params: data
      });
    },
    getAreaDetail (id) {
      return api.get(baseUrl + "/area/" + id);
    },
    postArea (data) {
      return api.post(baseUrl + "/area", data);
    },
    putArea (id, data) {
      return api.put(baseUrl + "/area/" + id, data);
    },
    deleteArea (id) {
      return api.delete(baseUrl + "/area/" + id);
    },
    getAreaNextId (prefCode) {
      return api.get(baseUrl + `/area/nextId/${prefCode}`);
    },
    // 請求書管理
    getRequestDocumentList (data) {
      return api.get(baseUrl + "/requestDocument", {
        params: data
      });
    },
    putRequestDocumentListConfig (data) {
      return api.put(baseUrl + "/requestDocument/config", data);
    },
    getRequestDocumentDetail (id) {
      return api.get(baseUrl + "/requestDocument/" + id);
    },
    postRequestDocument (data) {
      return api.post(baseUrl + "/requestDocument", data);
    },
    postRequestDocumentTempSave (data) {
      return api.post(baseUrl + "/requestDocument/tempSave", data);
    },
    republicRequestDocument (id, data) {
      return api.put(baseUrl + `/requestDocument/${id}/republic`, data);
    },
    putRequestDocument (id, data) {
      return api.put(baseUrl + "/requestDocument/" + id, data);
    },
    deleteRequestDocument (id) {
      return api.delete(baseUrl + "/requestDocument/" + id);
    },
    getRequestDocumentCSV (data) {
      return api.get(baseUrl + `/requestDocument/excel`, {
        params: data
      });
    },
    getRequestTypeList () {
      return api.get(baseUrl + `/requestDocument/requestType`);
    },
    generateRequestDocument (id, data) {
      return api.post(baseUrl + `/requestDocument/${id}/generate`, data);
    },
    previewRequestDocument (data) {
      return api.post(baseUrl + `/requestDocument/preview`, data, {
        responseType: 'blob'
      });
    },
    postRequestDocumentIncome (id, data) {
      return api.post(baseUrl + `/requestDocument/${id}/income`, data);
    },
    getRequestDocumentIncomeList (id, data) {
      return api.get(baseUrl + `/requestDocument/${id}/income`, {
        params: data
      });
    },
    putRequestDocumentIncome (id, incomeId, data) {
      return api.put(baseUrl + `/requestDocument/${id}/income/${incomeId}`, data);
    },
    deleteRequestDocumentIncome (id, incomeId) {
      return api.delete(baseUrl + `/requestDocument/${id}/income/${incomeId}`);
    },
    putRequestDocumentIncomeStatus (id, data) {
      return api.put(baseUrl + `/requestDocument/${id}/incomeStatus`, data);
    },
    getRequestDocumentListByParkingLotId (id, data) {
      return api.get(baseUrl + `/parkingLot/${id}/requestDocument`, {
        params: data
      });
    },
    // file
    bulkUpdate (taget, id, data) {
      return api.post(baseUrl + `/${taget}/${id}/attachment/bulkUpdate`, data);
    },
    bulkDelete (taget, id, data) {
      return api.post(baseUrl + `/${taget}/${id}/attachment/bulkDelete`, data);
    },
    // folder
    getFolderList () {
      return api.get(baseUrl + `/folder`);
    },
    getFolderDetail (id) {
      return api.get(baseUrl + `/folder/${id}`);
    },
    postFolder (data) {
      return api.post(baseUrl + `/folder`, data);
    },
    putFolder (id, data) {
      return api.put(baseUrl + `/folder/${id}`, data);
    },
    deleteFolder (id) {
      return api.delete(baseUrl + `/folder/${id}`);
    },
    // station
    getStationLine () {
      return api.get(baseUrl + `/station/line`);
    },
    getStation (lineId) {
      return api.get(baseUrl + `/station/line/${lineId}`);
    },
    // demo
    getPropertyList () {
      return api.get("/demoData/propertyList.json");
    },
    getProposalTargetList () {
      return api.get("/demoData/proposalTargetList.json");
    },

    // Spot
    getSpotList (data) {
      return api.get(baseUrl + "/spot", {
        params: data
      });
    },
    getSpotExcel (data) {
      return api.get(baseUrl + "/spot/excel", {
        params: data,
        responseType: 'blob'
      });
    },
    getSpot (id) {
      return api.get(baseUrl + "/spot/" + id);
    },
    postSpot (data) {
      return api.post(baseUrl + "/spot", data);
    },
    putSpot (id, data) {
      return api.put(baseUrl + "/spot/" + id, data);
    },
    deleteSpot (id) {
      return api.delete(baseUrl + "/spot/" + id);
    },
    getSpotOption () {
      return api.get(baseUrl + "/spot/optionValue");
    },
    getCompetingCompanyList (data) {
      return api.get(baseUrl + "/competingCompany", {
        params: data
      });
    },
    getCompetingCompany (id) {
      return api.get(baseUrl + "/competingCompany/" + id);
    },
    postCompetingCompany (data) {
      return api.post(baseUrl + "/competingCompany", data);
    },
    putCompetingCompany (id, data) {
      return api.put(baseUrl + "/competingCompany/" + id, data);
    },
    deleteCompetingCompany (id) {
      return api.delete(baseUrl + "/competingCompany/" + id);
    },
    postSpotSearch (data) {  // 検索
      return api.post(baseUrl + "/spot/search", data);
    },
    postSpotSearchSelect (data) {
      return api.post(baseUrl + "/spot/search/select", data);
    },
    putSpotSearchSelectConfig (data) {
      return api.put(baseUrl + "/spot/search/select/config", data);
    },
    getSpotSearchSelectExcel (data) {
      return api.post(baseUrl + "/spot/search/select/excel", data, {
        responseType: 'blob'
      });
    },
  };
}
